module.exports = __webpack_public_path__ + "static/img/page5-bg2.9e1227c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page5-bg2.png
// module id = f1F8
// module chunks = 215